import {isNullOrUndefined} from "../../services/Validator";

export default function SystemScreenInfoDialogHeaderTexts({icon, title, isBrevet}) {
    // Used in screen info dialog to display header info

    // BUILD
    if (isNullOrUndefined(icon) || isNullOrUndefined(title))
        return null
    return (
        <div className={"flex justify-start items-center space-x-[10px]"}>
            <div className={`${isBrevet ? "bg-greenStar/30" : "bg-primary/30"} w-[32px] min-w-[32px] h-[32px] min-h-[32px] flex justify-center items-center rounded-[8px]`}>
                <i className={`material-icons text-[16px] ${isBrevet ? "text-greenStar" : "text-primary"}`}>
                    {icon}
                </i>
            </div>
            <span className={"font-bold text-[18px] text-white"}>
                {title}
            </span>
        </div>
    );
}